import { DataV2API } from "../Endpoints";

class PharmacyGroup {
    get() {
        return DataV2API.get("/pharmacygroups");
    }

    add(pharmacyGroup) {
        return DataV2API.post("/pharmacygroups", pharmacyGroup);
    }

    update(pharmacyGroup) {
        return DataV2API.post("/pharmacygroup/" + pharmacyGroup.id, pharmacyGroup);
    }

    updateOrder(pharmacyGroupId, pharmacyArray) {
        return DataV2API.post(`/pharmacygroup/${pharmacyGroupId}/order/`, pharmacyArray);
    }

    delete(pharmacyGroupId) {
        return DataV2API.delete("/pharmacygroup/" + pharmacyGroupId);
    }

    assignPharmacyTo(pharmacyGroupId, pharmacyArray) {
        return DataV2API.post(`/pharmacygroup/${pharmacyGroupId}/assign/`, pharmacyArray);
    }

    unassignPharmacyFrom(pharmacyGroupId, pharmacyArray) {
        return DataV2API.post(`/pharmacygroup/${pharmacyGroupId}/remove/`, pharmacyArray);
    }
}

export default new PharmacyGroup();
